import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import AIForLeaders from "@/components/AIForLeaders";
import AILyftet from "@/components/AILyftet";
import AIMasterclass from "@/components/AIMasterclass";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const AISkilling = () => {
  return (
    <>
      <Helmet>
        <title>AI-skilling Programs | AI-labbet</title>
        <meta name="description" content="AI training programs for leaders and teams. Build AI capabilities with our comprehensive skilling courses and masterclasses." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="AI-skilling" />
        
        {/* Hero Section */}
        <main>
          <section className="relative py-20 md:py-32 overflow-hidden bg-background">
            {/* Decorative gradient borders */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
            
            {/* Content */}
            <div className="relative z-10 container mx-auto px-6 max-w-4xl text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                AI-skilling Programs
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
                Empower your organization with comprehensive AI education programs designed for leaders, teams, and professionals at every level.
              </p>
            </div>
          </section>

          {/* Three main sections */}
          <AIForLeaders />
          <AILyftet />
          <AIMasterclass />
          
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AISkilling;
